var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFootwear = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Footwear-Heels-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Footwear Heels 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.14 12.5a1 1 0 0 0 -0.87 -0.5h-2.6a0.48 0.48 0 0 0 -0.4 0.2 0.48 0.48 0 0 0 -0.09 0.43 59.74 59.74 0 0 1 1.46 8.54 1.5 1.5 0 0 0 1.49 1.33H5A1.5 1.5 0 0 0 6.5 21v-5.89a1 1 0 0 0 -0.14 -0.51Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.77 20.86 -3.87 -4.64a2 2 0 0 0 -1.53 -0.72H15.1a1.51 1.51 0 0 1 -1.27 -0.7L7.42 4.63a3.34 3.34 0 0 0 -1.51 -1.32L2.26 1.64a1.63 1.63 0 0 0 -1.53 0.11A1.6 1.6 0 0 0 0 3.1V10a0.5 0.5 0 0 0 0.5 0.5h3.77a2.54 2.54 0 0 1 2.17 1.24l5.24 9a3.51 3.51 0 0 0 3 1.74H23a1 1 0 0 0 0.77 -1.64Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFootwear);
export default ForwardRef;